
import { combineReducers } from 'redux';
import authReducer from "./reducers/slices/authSlice";
import adminReducer from "./reducers/slices/adminSlice";
import propertyReducer from "./reducers/slices/propertySlice";
import propertyCommentReducer from "./reducers/slices/propertyCommentSlice";
import bookingReducer from "./reducers/slices/bookingSlice";
import  notificationReducer  from "./reducers/slices/notificationSlice";
import dealRoomReducer from "./reducers/slices/dealRoomSlice";

import { AuthState } from './reducers/slices/authSlice';
import { AdminState } from './reducers/slices/adminSlice';
import { PropertyState } from './reducers/slices/propertySlice';
import { CommentState } from './reducers/slices/propertyCommentSlice';
import { BookingState } from './reducers/slices/bookingSlice';
import { NotificationState } from './reducers/types/notification';
import { DealRoomState } from './reducers/slices/dealRoomSlice';

interface RootState {
   auth: AuthState;
   admin: AdminState;
   property: PropertyState;
   propertyComment: CommentState;
   booking: BookingState;
   notification: NotificationState;
   dealroom: DealRoomState;
}

const rootReducer = combineReducers({
   auth: authReducer,
   admin: adminReducer,
   property: propertyReducer,
   propertyComment: propertyCommentReducer,
   booking: bookingReducer,
   notification: notificationReducer,
   dealroom: dealRoomReducer,
});

export default rootReducer;
export type { RootState };
